<template>
  <div class="m-input-box">
    <div class="mImport">
      <span class="label" v-if="label && typeInput!=='idCard'">{{label}}</span>
      <span class="label" v-if="label && typeInput === 'idCard'" @click="typeInputClick()"> <i class="icon icon-arrow-down"></i>{{label}}</span>
      <input  :value="value" @input="$emit('input', $event.target.value)" :placeholder="placeholder" @blur="blurHandel()"
             :disabled="disabled" :class="{forbidden:disabled}" :maxlength="maxlength" :type="type">
      <i v-if="disabled" class="icon" :class="disabledIcon"></i>
      <span class="unit" v-if="unit">{{unit}}</span>
    </div>
    <span class="error" :class="{ hasLabel:label }" v-show="errors()"><span class="icon icon-note"></span>{{validationErrors}}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
    },
    typeInput: {
      type: String
    },
    maxlength: {
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledIcon: {
      type: String(),
      default: 'icon-suo'
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    label: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      error: '',
      inputModel: this.value,
      validationErrors: null,
      modelExpression: this.$options._parentVnode.data.model.expression
    }
  },
  inject: ['$validation'],
  mounted () {
    this.$root.$on('showErr', (obj) => {
      this.errors()
    })
  },
  methods: {
    //    blurHandle(){

    //    },
    typeInputClick () {
      this.$emit('typeInputClick', true)
    },
    errors () {
      this.validationErrors = this.$validation.error(this.modelExpression)
      return this.validationErrors
    },
    blurHandel () {
      //      this.$emit('inputBlur',true)
      setTimeout(function () {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 300)
    }
  }

}
</script>
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .m-input-box {
    background: $light;
    padding: 0 15px !important;
    color: $dark;
    font-size: 16px;
    border-bottom: 1px solid #f5f5f5;
  }

  .label {
    flex: 0 0 80px;
    font-size: 17px;
  }
  .hasLabel{
    padding-left: 80px;
  }
  .mImport {
    align-items: center;
    height: 50px;
    display: flex;
    /*flex: 1;*/
  }
  input {
    border: none;
    width: 100%;
  }
  .error{
    color:#f25930 ;
    display: inline-block;
    padding-bottom: 10px;
  }
  .unit{
    flex: 0 0 auto;
  }
  //禁用
  .icon-suo{
    color: #cdcdcd;
    font-size: 22px;
  }
</style>
